import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
import { Form, FormItem } from "@worcket/common/components/controls";
import { withForm, isLoading } from "@worcket/common/hocs";

import {
  updateUserPassword,
  UPDATE_USER_PASSWORD
} from "../../store/actions/user";
import Button from "../../components/Button";
import {
  passwordValidateRules,
  passwordCompareRules
} from "../../utils/password";

const PasswordForm = ({ form, loading, onSubmit }) => {
  const { t } = useTranslation();
  return (
    <Form onSubmit={onSubmit} layout="vertical" data-test="user-password-form">
      <h1>{t("user:password.changePassword")}</h1>
      <p style={{ marginBottom: "2em" }}>
        {t("user:password.changePasswordHelp")}
      </p>
      <FormItem
        form={form}
        name="current-password"
        label={t("user:password.currentPassword")}
        rules={[{ required: true, message: t("form:emptyFieldValidation") }]}
        render={<Input type="password" />}
      />

      <FormItem
        form={form}
        name="new-password"
        label={t("user:password.newPassword")}
        rules={passwordValidateRules}
        render={<Input type="password" />}
      />

      <FormItem
        form={form}
        name="repeat-new-password"
        label={t("user:password.repeatPassword")}
        rules={passwordCompareRules(form, "new-password")}
        render={<Input type="password" />}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%"
        }}
      >
        <Button loading={loading} type="primary" size="lg" htmlType="submit">
          {t("user:password.updatePassword")}
        </Button>
      </div>
    </Form>
  );
};

const enhancer = compose(
  connect(
    null,
    { updateUserPassword }
  ),
  isLoading(UPDATE_USER_PASSWORD),
  withForm({
    onSubmit: (values, { updateUserPassword }) => updateUserPassword(values)
  })
);

export default enhancer(PasswordForm);
